import React, { useEffect, useState } from 'react';
import { Button, Drawer, Panel, Radio, RadioGroup } from 'rsuite';
import {
  fetchProductLabel,
} from '../../../apiService/apiService';

const SortDrawer = ({ sortAlias, setSortAlias, alsort, setAlsort }) => {
    const [label, setLabel] = useState([]);
      useEffect(() => {
        fetchProductLabel(setLabel);
      }, []);
  return (
    <Drawer size="xs" placement="right" open={sortAlias} onClose={() => setSortAlias(false)}>
      <Drawer.Header>
        <Drawer.Title>Sort By</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={() => setSortAlias(false)} appearance="primary" color="cyan">
            Confirm
          </Button>
        </Drawer.Actions>
      </Drawer.Header>
      <Drawer.Body>
        <Panel>
          <RadioGroup name="radio-group"
            value={alsort}
            onChange={(value) => setAlsort(value)}>SalePriceINR
            <Radio value="A"><b>Newest First</b></Radio>
            <Radio value="B"><b>Oldest First</b></Radio>
            <Radio value="C"><b>{label[0]?.attributes.AliasCode} : Ascending</b></Radio>
            <Radio value="D"><b>{label[0]?.attributes.AliasCode} : Descending</b></Radio>
            <Radio value="E"><b>{label[0]?.attributes.SalePriceINR} : Low to High</b></Radio>
            <Radio value="F"><b>{label[0]?.attributes.SalePriceINR} : High to Low</b></Radio>
            <Radio value="G"><b>Authorized : Newest First</b></Radio>
            <Radio value="H"><b>Authorized: Oldest First</b></Radio>
          </RadioGroup>
        </Panel>
      </Drawer.Body>
    </Drawer>
  );
};

export default SortDrawer;
